module.exports = __webpack_public_path__ + "img/crock-pot-corn-chowder.2f27c9e8.jpg";